<form class="form-inline">
  <div class="form-group hidden">
    <div class="input-group">
      <input name="datepicker"
             class="form-control height-1"
             ngbDatepicker
             #datepicker="ngbDatepicker"
             [autoClose]="true"
             (dateSelect)="onDateSelection($event)"
             [displayMonths]="(innerWidth < 769) ? 1 : 2"
             [minDate]="minDate"
             [dayTemplate]="t"
             outsideDays="hidden"
             [startDate]="fromDate!">
      <ng-template #t let-date let-focused="focused">
        <span class="custom-day"
              [class.focused]="focused"
              [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)"
              (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
          {{ date.day }}
        </span>
      </ng-template>
    </div>
  </div>
  <div class="form-group">
    <div class="input-group">
      <input #dpFromDate
             class="form-control" placeholder="Dal"
             name="dpFromDate"
             readonly
             (click)="datepicker.toggle()"
             [value]="formatter.format(fromDate)"
             (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" (click)="datepicker.toggle()" type="button"><i class="fa fa-calendar"></i> </button>
      </div>
    </div>
  </div>
  <div class="form-group ml-md-1">
    <div class="input-group">
      <input #dpToDate
             readonly
             (click)="datepicker.toggle()"
             class="form-control" placeholder="Al"
             name="dpToDate"
             [value]="formatter.format(toDate)"
             (input)="toDate = validateInput(toDate, dpToDate.value)">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" (click)="datepicker.toggle()" type="button"><i class="fa fa-calendar"></i> </button>
      </div>
    </div>
  </div>
</form>
